import { render, staticRenderFns } from "./ebt_transaction_poster.vue?vue&type=template&id=78b72716&"
import script from "./ebt_transaction_poster.vue?vue&type=script&lang=js&"
export * from "./ebt_transaction_poster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports